import { z } from "zod";

import { bulkTenderDocumentFormDataSchema } from "./bulk-tender-document-schema.ts";

const bulkTenderDocumentFailureSchema = z.object({
	quoteId: z.number().int().positive(),
	poNumber: z.number().int().nonnegative(),
	documentType: z.string().min(1),
	reason: z.string().min(1),
});

export const bulkTenderDocumentsEmailRequestSchema = z.object({
	quoteIds: z.array(z.number().int().positive()).min(1).max(500),
	formData: bulkTenderDocumentFormDataSchema,
	subject: z.string().max(255).optional(),
	messageBody: z.string().max(10_000).optional(),
	recipients: z.array(z.string().email()).max(100),
	includeTrackingLink: z.boolean(),
});

export const bulkTenderDocumentsEmailResponseSchema = z.object({
	status: z.literal("sent"),
	documentCount: z.number().int().positive(),
	failures: z.array(bulkTenderDocumentFailureSchema),
});

export type BulkTenderDocumentsEmailRequest = z.infer<
	typeof bulkTenderDocumentsEmailRequestSchema
>;
export type BulkTenderDocumentsEmailResponse = z.infer<
	typeof bulkTenderDocumentsEmailResponseSchema
>;
